export const siteSections = [
  { id: "hero", label: "Home" },
  { id: "work", label: "Work" },
  { id: "contact", label: "Contact" },
] as const;

export const socialLinks = [
  {
    platform: "LinkedIn",
    href: "https://www.linkedin.com/in/oleksandrkucenko/",
    ariaLabel: "Visit Alexandr Kutsenko on LinkedIn",
  },
  {
    platform: "GitHub",
    href: "https://github.com/Alexandr-gw",
    ariaLabel: "Visit Alexandr Kutsenko on GitHub",
  },
] as const;

export type HeroSkillIcon = "react" | "typescript" | "nodejs" | "postgresql" | "aws";

export type HeroSkillTone = "library" | "language" | "runtime" | "database" | "cloud";

type HeroSkill = {
  readonly name: string;
  readonly icon: HeroSkillIcon;
  readonly tone: HeroSkillTone;
};

const heroCoreStack = [
  {
    name: "React",
    icon: "react",
    tone: "library",
  },
  {
    name: "TypeScript",
    icon: "typescript",
    tone: "language",
  },
  {
    name: "Node.js",
    icon: "nodejs",
    tone: "runtime",
  },
  {
    name: "PostgreSQL",
    icon: "postgresql",
    tone: "database",
  },
  {
    name: "AWS",
    icon: "aws",
    tone: "cloud",
  },
] as const satisfies readonly HeroSkill[];

export const siteContent = {
  person: {
    fullName: "Alexandr Kutsenko",
    shortName: "Alexandr",
    brandName: "Alex Kutsenko.dev",
    location: "Alberta, Canada",
    email: "alex.kutsenko11@gmail.com",
  },
  hero: {
    sectionId: siteSections[0].id,
    title: "Full-Stack Software Developer",
    intro:
      "Building production-ready React and Node.js applications with auth, payments, scheduling, background jobs, and real deployment infrastructure.",
    image: {
      src: "/1671754412049.jpeg",
      alt: "Portrait of Alexandr Kutsenko",
    },
    coreStackLabel: "Core stack",
    coreStack: heroCoreStack,
    portraitNote: {
      eyebrow: "Available for full-stack roles",
      text: "React interfaces, Node services, and product-minded implementation across the full stack.",
    },
  },
  work: {
    sectionId: siteSections[1].id,
    projects: [
      {
        title: "Alex Tap",
        description:
          "A scheduling app for service teams featuring public booking, Stripe payments, worker schedules, and role-based dashboards.",
        image: "/alex-tap-dashboard.png",
        imageAlt: "Preview of the Alex Tap scheduling platform interface",
        stack: ["React", "TypeScript", "NestJS", "PostgreSQL", "Stripe", "Redis"],
        features: [
          "Public booking with Stripe checkout",
          "Role-based dashboards for managers and workers",
          "Redis/BullMQ reminders and workers",
        ],
        github: "https://github.com/Alexandr-gw/alex-tap",
        liveDemo: "https://alex-tap.alexkutsenko.dev/",
      },
    ],
  },
  contact: {
    sectionId: siteSections[2].id,
    title: "Get in Touch",
    description: "Have a project or role in mind? I’d love to hear from you.",
  },
  footer: {
    note: "Built with React and a focus on deliberate interface details.",
    rightsText: "All rights reserved.",
  },
} as const;
